const colors = {
  background: '#F3F2F3',
  black: '#000000',
  blue: '#1B75DF',
  borderColor: '#B4B3BA',
  borderSection: '#b4b4b4',
  boxBorder: '#CCCCCC',
  buttonBlack: '#2C2C2C',
  dialogFooter: '#F7F7F7',
  dividerGrey: '#C8C9CA',
  errorPlaceholder: '#ff8787',
  errorRed: '#D42A54',
  iconTeal: '#0C8599',
  red: '#fa5252',
  shadow: '#2525251A',
  theme: '#827127',
  white: '#ffffff',
};

export default colors;
